import { AccessTypeEnum, UserProfile } from 'generated/graphql'

export default function userHasPermission(user: UserProfile, permission: AccessTypeEnum): boolean {
  return user?.permission?.accesses?.map((item) => item.title)?.includes(permission) || false
}
